import { defineComponent as _defineComponent } from 'vue'
import { NeoIcon } from '@kodadot1/brick'


export default /*#__PURE__*/_defineComponent({
  __name: 'IdentitySocial',
  props: {
    twitter: null,
    showTwitter: { type: Boolean },
    discord: null,
    showDiscord: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,NeoIcon }
}

})